/* TPS Adapter Finder - spec-led, inline, live.
   Compatibility truth for a laptop charger: Brand + Pin size + Wattage (and voltage).
   An adapter with the same brand, pin and voltage and EQUAL OR HIGHER wattage will run a
   laptop that shipped with a lower-wattage one (more headroom); lower wattage will not.
   Type C is USB-PD, so higher wattage works regardless of the listed voltage.
   Inputs: Brand + Wattage + Pin (visual picker), plus an optional laptop model / part number box.
   No framework, ES5-safe. */
(function () {
  'use strict';
  var ROOT = document.getElementById('tpsaf');
  if (!ROOT) return;

  var FEED_URL  = ROOT.getAttribute('data-feed') || '/collections/all-laptop-chargers?view=afeed';
  var WA_NUMBER = (ROOT.getAttribute('data-wa') || '917388305552').replace(/[^0-9]/g, '');
  var CUR       = ROOT.getAttribute('data-currency') || '₹';
  var WRULE     = ROOT.getAttribute('data-wattrule') || 'higher'; // 'higher' | 'exact'
  var MAX_RESULTS = 4;   // cap the list: exact-wattage matches first, then a couple of higher-wattage "also works"
  var FEED_KEY  = 'tpsaf_feed_v1';

  var form       = document.getElementById('tpaForm');
  var brandInput = document.getElementById('tpaBrand');
  var brandBtn   = document.getElementById('tpaBrandBtn');
  var brandText  = brandBtn ? brandBtn.querySelector('.tpf-select-btn-text') : null;
  var brandDrop  = document.getElementById('tpaBrandDropdown');
  var brandField = document.getElementById('tpaBrandField');
  var wattSelect = document.getElementById('tpaWatt');
  var wattField  = document.getElementById('tpaWattField');
  var pinInput   = document.getElementById('tpaPin');
  var pinPicker  = document.getElementById('tpaPinPicker');
  var gradeInput = document.getElementById('tpaGrade');
  var gradePicker= document.getElementById('tpaGradePicker');
  var pinField   = document.getElementById('tpaPinField');
  var gradeField = document.getElementById('tpaGradeField');
  var modelInput = document.getElementById('tpaModel');
  var resultsWrap= document.getElementById('tpaResults');

  /* ---------- brand dropdown ---------- */
  if (brandBtn && brandDrop) {
    brandBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (brandDrop.classList.contains('tpf-open')) closeDrop();
      else { brandDrop.classList.add('tpf-open'); brandBtn.setAttribute('aria-expanded', 'true'); }
    });
    function closeDrop(){ brandDrop.classList.remove('tpf-open'); brandBtn.setAttribute('aria-expanded','false'); }
    var bi = brandDrop.querySelectorAll('.tpf-dropdown-item');
    for (var k=0;k<bi.length;k++) bi[k].addEventListener('click', function(e){
      e.stopPropagation();
      var v=this.getAttribute('data-value');
      brandInput.value=v;
      if(brandText){brandText.textContent=v;brandText.classList.add('tpf-has-value');}
      for(var j=0;j<bi.length;j++) bi[j].classList.remove('tpf-selected');
      this.classList.add('tpf-selected');
      if(brandField) brandField.classList.remove('tpf-has-error');
      closeDrop();
      unlockForm();                                        // brand chosen: open up wattage, grade + pin
      buildPins(v); buildGrades(v); applyBrandWatts(v); syncGradeVisibility();    // immediate (fallback), then refine from live feed
      loadFeed().then(function(){ buildPins(v); buildGrades(v); applyBrandWatts(v); syncGradeVisibility(); }).catch(function(){});
      if (resultsWrap && resultsWrap.getAttribute('data-has')==='1') doSearch();
    });
    document.addEventListener('click', function(e){ if(!brandDrop.contains(e.target)&&e.target!==brandBtn) closeDrop(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrop(); });
  }

  /* ---------- pin + grade pickers (delegated; tiles are built per brand from live stock) ---------- */
  function closestOf(el, cls){ while(el && el!==document){ if(el.classList && el.classList.contains(cls)) return el; el=el.parentNode; } return null; }
  if (pinPicker) pinPicker.addEventListener('click', function(e){
    var btn=closestOf(e.target, 'tpa-pin'); if(!btn) return;
    var v=btn.getAttribute('data-pin'), on=pinPicker.querySelectorAll('.tpa-pin'), j;
    if (pinInput.value===v){ pinInput.value=''; btn.classList.remove('tpa-pin--on'); }
    else { pinInput.value=v; for(j=0;j<on.length;j++) on[j].classList.remove('tpa-pin--on'); btn.classList.add('tpa-pin--on'); }
    if(pinField) pinField.classList.remove('tpf-has-error');
    syncGradeVisibility();
    if (resultsWrap && resultsWrap.getAttribute('data-has')==='1') doSearch();
  });
  if (gradePicker) gradePicker.addEventListener('click', function(e){
    var btn=closestOf(e.target, 'tpa-grade'); if(!btn) return;
    gradeInput.value=btn.getAttribute('data-grade');
    var on=gradePicker.querySelectorAll('.tpa-grade'), j;
    for(j=0;j<on.length;j++) on[j].classList.remove('tpa-grade--on');
    btn.classList.add('tpa-grade--on');
    if (resultsWrap && resultsWrap.getAttribute('data-has')==='1') doSearch();
  });

  /* ---------- helpers ---------- */
  function norm(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim(); }
  function alnum(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,''); }
  function esc(s){ return (''+s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  var BRANDS = ['dell','hp','lenovo','asus','acer','apple','microsoft','samsung','msi','sony','toshiba'];
  var BRAND_DISP = {dell:'Dell',hp:'HP',lenovo:'Lenovo',asus:'Asus',acer:'Acer',apple:'Apple',microsoft:'Microsoft',samsung:'Samsung',msi:'MSI',sony:'Sony',toshiba:'Toshiba'};
  // Shown before the live feed loads; the feed then narrows this to the pins we actually stock for the brand.
  var PIN_FALLBACK = {
    Dell:['Type C','7.4mm','4.5mm'],
    HP:['Type C','7.4mm','4.5mm'],
    Lenovo:['Type C','Slim Tip','Round Tip'],
    Asus:['Type C','4.0mm','4.5mm','5.5mm','6.0mm'],
    Acer:['Type C','5.5mm','3.0mm'],
    Apple:['Type C'],
    Microsoft:['Type C']
  };
  function brandOf(pr){
    var t=' '+norm(pr.t)+' ';
    for (var i=0;i<BRANDS.length;i++){ if (t.indexOf(' '+BRANDS[i]+' ')>-1) return BRAND_DISP[BRANDS[i]]; }
    var v=norm(pr.v);
    for (i=0;i<BRANDS.length;i++){ if (v===BRANDS[i]) return BRAND_DISP[BRANDS[i]]; }
    return pr.v || '';
  }
  function wattOf(pr){
    // Title first: it is human-written and reliable, and the wattage metafield is sometimes mis-tagged.
    var t=norm(pr.t); var m=t.match(/(\d{2,3})\s*(?:w|watt)\b/);
    if (m) return parseInt(m[1],10);
    if (pr.w){ var mm=(''+pr.w).match(/(\d{2,3})/); if(mm) return parseInt(mm[1],10); }
    return 0;
  }
  function voltOf(pr){
    var t=(pr.t||'').toLowerCase().replace(/[^0-9a-z. ]+/g,' ');
    var m=t.match(/(\d{1,3}(?:\.\d)?)\s*v\b/);
    return m ? parseFloat(m[1]) : 0;
  }
  function canonPin(raw, title){
    var s=(raw||'').toLowerCase();
    var t=(title||'').toLowerCase();
    function mm(str){ var m=str.match(/(\d(?:\.\d)?)\s*mm/); return m?m[1]:null; }
    // metafield first
    if (/type\s*-?\s*c|usb\s*-?\s*c/.test(s)||/type\s*-?\s*c|usb\s*-?\s*c/.test(t)) return 'Type C';
    var d=mm(s)||(!/slim|round|magsafe|\btip\b/.test(s)?null:null);
    if (!d){ // try title mm only if metafield had none
      if (!s) d=mm(t);
    }
    if (d){ if(d==='4')d='4.0'; if(d==='5')d='5.0'; if(d==='6')d='6.0'; if(d==='3')d='3.0'; return d+'mm'; }
    if (/slim\s*tip|rectangular/.test(s)||/slim\s*tip|rectangular/.test(t)) return 'Slim Tip';
    if (/round\s*tip/.test(s)||/round\s*tip/.test(t)) return 'Round Tip';
    if (/\bt\s*tip\b/.test(s)||/\bt\s*tip\b/.test(t)) return 'T Tip';
    if (/\bl\s*tip\b/.test(s)||/\bl\s*tip\b/.test(t)) return 'L Tip';
    if (/magsafe/.test(s)||/magsafe/.test(t)) return 'MagSafe';
    // HP conventions when no explicit mm
    if (/blue\s*pin|small\s*pin/.test(t)) return '4.5mm';
    if (/big\s*pin/.test(t)) return '7.4mm';
    var dm=mm(t); if(dm){ if(dm==='4')dm='4.0'; if(dm==='5')dm='5.0'; if(dm==='6')dm='6.0'; if(dm==='3')dm='3.0'; return dm+'mm'; }
    return '';
  }
  function gradeOf(pr){
    var g=(pr.g||'').toLowerCase();
    if (g.indexOf('original')>-1) return 'Original';
    if (g.indexOf('oem')>-1) return 'OEM';
    if (g.indexOf('compatible')>-1) return 'Compatible';
    var t=(pr.t||'').toLowerCase();
    if (/\boriginal\b/.test(t)) return 'Original';
    if (/\boem\b/.test(t)) return 'OEM';
    if (/\bcompatible\b/.test(t)) return 'Compatible';
    return '';
  }
  function gradeRank(g){ return g==='Original'?0:(g==='OEM'?1:(g==='Compatible'?2:3)); }

  /* ---------- brand-aware form: pick Brand, then Wattage, then Grade/Pin ---------- */
  function countKeys(o){ var n=0,k; for(k in o){ if(o.hasOwnProperty(k)) n++; } return n; }
  function unlockForm(){
    if(wattSelect) wattSelect.disabled=false;
    if(pinField) pinField.classList.remove('tpa-pinrow--lock');
  }
  // Grade is optional and shows ONLY while the required trio (brand + wattage + pin) is all set.
  // Reactive both ways: it hides again the moment any of the three is cleared or reset, and a
  // hidden grade is cleared so it can never silently filter results the shopper cannot see.
  function syncGradeVisibility(){
    if(!gradeField) return;
    var b=brandInput&&brandInput.value, w=wattSelect&&wattSelect.value, p=pinInput&&pinInput.value;
    if(b && w && p){
      gradeField.classList.remove('tpa-graderow--hide');
    } else {
      gradeField.classList.add('tpa-graderow--hide');
      if(gradeInput && gradeInput.value){ gradeInput.value=''; buildGrades(b||''); }   // drop stale hidden filter
    }
  }

  // Icon + one-line hint per known pin. Any pin we stock but have no art for still renders (generic icon),
  // so a new size added to the catalogue (e.g. an Asus 4.0mm) shows up on its own.
  var GENERIC_PIN='<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="8" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="2" fill="currentColor"/></svg>';
  var PIN_META={
    'Type C':{hint:'USB-C',svg:'<svg viewBox="0 0 32 32" fill="none"><rect x="6" y="12" width="20" height="8" rx="4" stroke="currentColor" stroke-width="2"/><line x1="11" y1="16" x2="21" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'},
    '7.4mm':{hint:'Large round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="9" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="2.4" fill="currentColor"/></svg>'},
    '4.5mm':{hint:'Small round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="6.5" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="1.8" fill="currentColor"/></svg>'},
    '4.0mm':{hint:'Small round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="6" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="1.6" fill="currentColor"/></svg>'},
    '5.5mm':{hint:'Medium round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="8" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="2" fill="currentColor"/></svg>'},
    '3.0mm':{hint:'Thin round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="5" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="1.5" fill="currentColor"/></svg>'},
    '6.0mm':{hint:'Large round',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="9.5" stroke="currentColor" stroke-width="2"/><circle cx="16" cy="16" r="2.2" fill="currentColor"/></svg>'},
    '6.5mm':{hint:'Large round',svg:GENERIC_PIN},
    '4.8mm':{hint:'Small round',svg:GENERIC_PIN},
    'Slim Tip':{hint:'Rectangular',svg:'<svg viewBox="0 0 32 32" fill="none"><rect x="8" y="13" width="16" height="6" rx="1.5" stroke="currentColor" stroke-width="2"/></svg>'},
    'Round Tip':{hint:'Round, center pin',svg:'<svg viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="7" stroke="currentColor" stroke-width="2"/></svg>'},
    'T Tip':{hint:'Apple T-shape',svg:GENERIC_PIN},
    'L Tip':{hint:'Apple L-shape',svg:GENERIC_PIN},
    'MagSafe':{hint:'Apple magnetic',svg:'<svg viewBox="0 0 32 32" fill="none"><rect x="9" y="13" width="14" height="6" rx="2" stroke="currentColor" stroke-width="2"/></svg>'}
  };
  var PIN_ORDER=['Type C','7.4mm','6.5mm','6.0mm','5.5mm','4.8mm','4.5mm','4.0mm','3.0mm','Slim Tip','Round Tip','T Tip','L Tip','MagSafe'];
  function orderedKeys(set, order){
    var out=[], seen={}, i, k;
    for(i=0;i<order.length;i++){ if(set[order[i]]){ out.push(order[i]); seen[order[i]]=1; } }
    for(k in set){ if(set.hasOwnProperty(k) && !seen[k]) out.push(k); }   // anything new the feed carries
    return out;
  }
  function pinSetFor(brand){
    if(_parsed && pinsByBrand[brand] && countKeys(pinsByBrand[brand])) return pinsByBrand[brand];
    if(PIN_FALLBACK[brand]){ var o={}; for(var i=0;i<PIN_FALLBACK[brand].length;i++) o[PIN_FALLBACK[brand][i]]=1; return o; }
    return null;
  }
  function buildPins(brand){
    if(!pinPicker) return;
    var set=pinSetFor(brand); if(!set){ pinPicker.innerHTML=''; return; }
    var list=orderedKeys(set, PIN_ORDER), html='', i;
    for(i=0;i<list.length;i++){
      var p=list[i], meta=PIN_META[p]||{hint:'',svg:GENERIC_PIN};
      var on=(pinInput && pinInput.value===p)?' tpa-pin--on':'';
      html+='<button type="button" class="tpa-pin'+on+'" data-pin="'+esc(p)+'">'+meta.svg+'<b>'+esc(p)+'</b><span>'+esc(meta.hint||'')+'</span></button>';
    }
    pinPicker.innerHTML=html;
    if(pinInput && pinInput.value && !set[pinInput.value]) pinInput.value='';
  }

  var GRADE_ORDER=['Original','OEM','Compatible'];
  function gradeSetFor(brand){
    if(_parsed && gradesByBrand[brand] && countKeys(gradesByBrand[brand])) return gradesByBrand[brand];
    return null;
  }
  function buildGrades(brand){
    if(!gradePicker) return;
    var set=gradeSetFor(brand);
    var html='<button type="button" class="tpa-grade'+((!gradeInput.value)?' tpa-grade--on':'')+'" data-grade="">Any</button>';
    if(set){ for(var i=0;i<GRADE_ORDER.length;i++){ var g=GRADE_ORDER[i]; if(set[g]){ var on=(gradeInput.value===g)?' tpa-grade--on':''; html+='<button type="button" class="tpa-grade'+on+'" data-grade="'+g+'">'+g+'</button>'; } } }
    gradePicker.innerHTML=html;
    if(gradeInput.value && (!set || !set[gradeInput.value])) gradeInput.value='';
  }

  function allowedWatts(brand){
    if(!brand) return null;
    if(_parsed && wattsByBrand[brand] && countKeys(wattsByBrand[brand])) return wattsByBrand[brand];
    return null;                                             // feed not ready yet: keep the full list
  }
  function applyBrandWatts(brand){
    if(!wattSelect) return;
    var allow=allowedWatts(brand);
    if(!allow) return;                                       // leave existing options until the feed lands
    var cur=wattSelect.value, ws=[], k;
    for(k in allow){ if(allow.hasOwnProperty(k)) ws.push(parseInt(k,10)); }
    ws.sort(function(a,b){ return a-b; });
    var html='<option value="">Select watts</option>', keep=false;
    for(var i=0;i<ws.length;i++){ html+='<option value="'+ws[i]+'">'+ws[i]+'W</option>'; if(String(ws[i])===cur) keep=true; }
    wattSelect.innerHTML=html;
    wattSelect.value = keep?cur:'';
  }
  function refineForm(){ var b=brandInput&&brandInput.value; if(b){ buildPins(b); buildGrades(b); applyBrandWatts(b); } }

  /* ---------- feed ---------- */
  var _feed=null, _parsed=null, pinsByBrand={}, wattsByBrand={}, gradesByBrand={};
  function previewParam(){ var m=(location.search||'').match(/[?&]preview_theme_id=(\d+)/); return m?'&preview_theme_id='+m[1]:''; }
  function pageUrl(n){ return FEED_URL+(FEED_URL.indexOf('?')>-1?'&':'?')+'page='+n+previewParam(); }
  function getJSON(u){ return fetch(u,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(t){return JSON.parse(t);}); }
  function loadFeed(){
    if (_parsed) return Promise.resolve(_parsed);
    try{ var c=sessionStorage.getItem(FEED_KEY); if(c){ _feed=JSON.parse(c); parseAll(); return Promise.resolve(_parsed);} }catch(e){}
    return getJSON(pageUrl(1)).then(function(first){
      var all=first.products||[]; var pages=first.pages||1;
      if (pages<=1) return all;
      var reqs=[]; for(var pg=2;pg<=pages;pg++) reqs.push(getJSON(pageUrl(pg)).then(function(d){return d.products||[];}).catch(function(){return [];}));
      return Promise.all(reqs).then(function(ch){ for(var i=0;i<ch.length;i++) all=all.concat(ch[i]); return all; });
    }).then(function(all){ _feed=all; try{sessionStorage.setItem(FEED_KEY,JSON.stringify(all));}catch(e){} parseAll(); return _parsed; });
  }
  function parseAll(){
    _parsed=[]; pinsByBrand={}; wattsByBrand={}; gradesByBrand={};
    for (var i=0;i<_feed.length;i++){
      var pr=_feed[i];
      var b=brandOf(pr), p=canonPin(pr.pin, pr.t), w=wattOf(pr), gr=gradeOf(pr);
      _parsed.push({ pr:pr, brand:b, watt:w, pin:p, volt:voltOf(pr), grade:gr });
      if(b && p){ if(!pinsByBrand[b]) pinsByBrand[b]={}; pinsByBrand[b][p]=1; }
      if(b && w>0){ if(!wattsByBrand[b]) wattsByBrand[b]={}; wattsByBrand[b][w]=1; }
      if(b && gr){ if(!gradesByBrand[b]) gradesByBrand[b]={}; gradesByBrand[b][gr]=1; }
    }
    refineForm();
  }

  /* ---------- matching ---------- */
  function resolveSeed(A, text, brand){
    var q=norm(text); if(!q) return null;
    var qa=alnum(text);
    var toks=q.split(' ').filter(function(x){return x.length>=2;});
    var best=null, bestScore=-1;
    for (var i=0;i<A.length;i++){
      var a=A[i], pr=a.pr;
      if (brand && a.brand!==brand) continue;
      var hay=' '+norm(pr.t)+' '+norm(pr.s)+' '+norm(pr.pn)+' '+norm(pr.md)+' ';
      var hayA=alnum(pr.s)+'|'+alnum(pr.pn)+'|'+alnum(pr.t);
      var sc=0;
      if (qa.length>=4 && hayA.indexOf(qa)>-1) sc+=100;           // exact part/sku hit
      for (var t=0;t<toks.length;t++){ if (hay.indexOf(' '+toks[t]+' ')>-1) sc+=10; else if (hay.indexOf(toks[t])>-1) sc+=4; }
      if (sc>bestScore && sc>=10){ bestScore=sc; best=a; }
    }
    return best;
  }

  function compatible(A, B, W, P, V, G){
    var base=[]; var i,a;
    for (i=0;i<A.length;i++){ a=A[i]; if (B && a.brand!==B) continue; if (G && a.grade!==G) continue; base.push(a); }
    var basePin = P ? base.filter(function(x){return x.pin===P;}) : base;

    var cand;
    if (W>0){
      // voltage anchor: explicit V, else the pin family's voltage(s) (barrel pins share a voltage per brand+pin)
      var anchorV={};
      if (V>0) anchorV[V]=1;
      else {
        var exactV=basePin.filter(function(x){return x.watt===W;});
        var src=exactV.length?exactV:basePin;
        src.forEach(function(x){ if(x.volt>0) anchorV[x.volt]=1; });
      }
      if (WRULE==='higher' && P){
        if (P==='Type C') cand=basePin.filter(function(x){return x.watt>=W;});           // USB-PD: voltage negotiated
        else if (Object.keys(anchorV).length) cand=basePin.filter(function(x){return x.watt>=W && anchorV[x.volt];});
        else cand=basePin.filter(function(x){return x.watt>=W;});
      } else {
        cand=basePin.filter(function(x){return x.watt===W;});   // exact-only (no pin given, or exact rule)
      }
    } else {
      cand=basePin.slice();  // model resolved without a wattage
    }

    var exact=cand.filter(function(x){return !W || x.watt===W;});
    var higher=cand.filter(function(x){return W && x.watt>W;});
    exact.sort(function(a,b){
      var ai=a.pr.a?0:1, bi=b.pr.a?0:1; if(ai!==bi) return ai-bi;
      var gr=gradeRank(a.grade)-gradeRank(b.grade); if(gr) return gr;
      return (a.pr.p||0)-(b.pr.p||0);
    });
    higher.sort(function(a,b){ if(a.watt!==b.watt) return a.watt-b.watt; var ai=a.pr.a?0:1,bi=b.pr.a?0:1; if(ai!==bi)return ai-bi; return (a.pr.p||0)-(b.pr.p||0); });
    var seen={}, out=[];
    exact.forEach(function(x){ if(!seen[x.pr.h]){seen[x.pr.h]=1; out.push({a:x,also:false});} });
    higher.forEach(function(x){ if(!seen[x.pr.h]){seen[x.pr.h]=1; out.push({a:x,also:true});} });
    return out;
  }

  function similar(A, B){
    if(!B) return [];
    var out=A.filter(function(x){return x.brand===B;});
    out.sort(function(a,b){ var ai=a.pr.a?0:1,bi=b.pr.a?0:1; if(ai!==bi)return ai-bi; return (a.pr.p||0)-(b.pr.p||0); });
    return out.slice(0,MAX_RESULTS).map(function(x){return {a:x,also:false};});
  }

  /* ---------- render ---------- */
  function inr(paise){ var v=Math.round((paise||0))/100; try{return CUR+v.toLocaleString('en-IN',{maximumFractionDigits:0});}catch(e){return CUR+Math.round(v);} }
  function specChips(a){
    var h='';
    if (a.pin) h+='<span class="tpa-spec">'+esc(a.pin)+'</span>';
    if (a.watt) h+='<span class="tpa-spec">'+a.watt+'W</span>';
    if (a.volt) h+='<span class="tpa-spec">'+a.volt+'V</span>';
    return h;
  }
  function card(item){
    var a=item.a, pr=a.pr, g=a.grade;
    var gclass=g==='Original'?'o':(g==='OEM'?'m':(g==='Compatible'?'c':'x'));
    var price=pr.p||0, comp=pr.c||0, hasComp=comp>price&&price>0, off=hasComp?Math.round((comp-price)/comp*100):0;
    var oos=!pr.a;
    var h='<a class="tpfc'+(oos?' tpfc--oos':'')+'" href="/products/'+encodeURIComponent(pr.h)+'">';
    h+='<div class="tpfc__img">'+(pr.i?'<img src="'+esc(pr.i)+'" alt="" loading="lazy">':'')+(oos?'<span class="tpfc__oos">Out of stock</span>':'')+'</div>';
    h+='<div class="tpfc__b"><div class="tpfc__badges">';
    if (g) h+='<span class="tpfc__g tpfc__g--'+gclass+'">'+esc(g)+'</span>';
    if (item.also) h+='<span class="tpfc__fit">Also works, more power</span>';
    h+='</div>';
    h+='<div class="tpfc__t">'+esc(pr.t)+'</div>';
    h+='<div class="tpa-specs">'+specChips(a)+'</div>';
    h+='<div class="tpfc__p"><span class="tpfc__now">'+inr(price)+'</span>';
    if (hasComp) h+='<span class="tpfc__mrp">'+inr(comp)+'</span><span class="tpfc__off">'+off+'% off</span>';
    h+='</div><span class="tpfc__cta">View details &rarr;</span></div></a>';
    return h;
  }
  function waLink(label){ return 'https://wa.me/'+WA_NUMBER+'?text='+encodeURIComponent('Hi TPSTECH, I need the right charger for my '+(label||'')+' laptop. Here is a photo of my old adapter label:'); }
  function waSvg(){ return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12a11.93 11.93 0 001.64 6.07L0 24l6.09-1.6A11.93 11.93 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52z" fill="#fff" opacity="0.25"/><path d="M17.47 14.38c-.28-.14-1.65-.81-1.9-.9-.26-.1-.44-.14-.63.14-.19.27-.72.9-.88 1.08-.16.18-.33.2-.61.07-.28-.14-1.19-.44-2.27-1.4-.84-.75-1.4-1.67-1.57-1.96-.16-.28-.02-.44.12-.58.13-.13.28-.33.42-.5.14-.16.19-.28.28-.46.1-.18.05-.35-.02-.49-.07-.14-.63-1.51-.86-2.07-.23-.55-.46-.47-.63-.48l-.54-.01c-.18 0-.47.07-.72.33-.25.27-.95.93-.95 2.27s.97 2.63 1.11 2.81c.14.18 1.91 2.92 4.63 4.09.65.28 1.15.45 1.55.57.65.2 1.24.17 1.71.1.52-.08 1.65-.67 1.88-1.32.23-.65.23-1.2.16-1.32-.07-.11-.25-.18-.54-.32z" fill="#fff"/></svg>'; }
  function set(h){ resultsWrap.setAttribute('data-has','1'); resultsWrap.innerHTML=h; scrollToResults(); }
  function grid(list){ var h='<div class="tpf-grid">'; for(var i=0;i<list.length;i++) h+=card(list[i]); return h+'</div>'; }

  function renderExact(list,label,noPin){
    var shown=list.slice(0,MAX_RESULTS);
    var h='<div class="tpf-rhead"><strong>'+list.length+'</strong> '+(list.length===1?'charger':'chargers')+' for <span>'+esc(label)+'</span>'+(list.length>shown.length?' <em>(closest '+shown.length+' shown)</em>':'')+'</div>';
    if (noPin) h+='<div class="tpa-hint">Different pin sizes are shown. Pick your pin above to narrow to the exact fit and see higher-wattage options that also work.</div>';
    h+=grid(shown);
    h+='<div class="tpf-helpbar"><div class="tpf-helpbar__t"><strong>Not sure which fits?</strong> Send a photo of your old adapter and we will confirm the exact match.</div><a class="tpf-wa-btn tpf-wa-btn--sm" href="'+waLink(label)+'" target="_blank" rel="noopener">'+waSvg()+'Ask on WhatsApp</a></div>';
    set(h);
  }
  function renderSimilar(list,label,unresolved){
    var brandWord=esc(label.split(' ')[0]||'');
    var head=unresolved
      ? '<strong>We could not match &ldquo;'+esc(label)+'&rdquo;</strong><span>Here are '+brandWord+' chargers. Pick your wattage and pin above for the exact fit, or confirm on WhatsApp.</span>'
      : '<strong>No exact match for &ldquo;'+esc(label)+'&rdquo;</strong><span>These '+brandWord+' chargers are close. Confirm the wattage and pin before you buy.</span>';
    var h='<div class="tpf-similar-head">'+head+'</div>';
    h+=grid(list);
    h+='<div class="tpf-rfoot tpf-rfoot--wa"><a class="tpf-wa-btn" href="'+waLink(label)+'" target="_blank" rel="noopener">'+waSvg()+'Confirm my charger on WhatsApp</a></div>';
    set(h);
  }
  function renderEmpty(label){
    var h='<div class="tpf-empty"><div class="tpf-empty__h">No match for &ldquo;'+esc(label)+'&rdquo; yet</div>';
    h+='<p class="tpf-empty__p">Send a photo of the label on your old adapter (it shows the wattage, voltage and pin) and we will confirm the exact charger, usually within a few minutes.</p>';
    h+='<a class="tpf-wa-btn" href="'+waLink(label)+'" target="_blank" rel="noopener">'+waSvg()+'Send a photo on WhatsApp</a></div>';
    set(h);
  }
  function loading(){ resultsWrap.setAttribute('data-has','1'); resultsWrap.innerHTML='<div class="tpf-loading"><span class="tpf-spin"></span>Searching our live stock&hellip;</div>'; }
  var _scrolled=false; function scrollToResults(){ if(_scrolled)return; _scrolled=true; try{resultsWrap.scrollIntoView({behavior:'smooth',block:'start'});}catch(e){} }

  /* ---------- run ---------- */
  function doSearch(){
    var brand=(brandInput&&brandInput.value||'').trim();
    var wattStr=(wattSelect&&wattSelect.value||'').trim();
    var pin=(pinInput&&pinInput.value||'').trim();
    var grade=(gradeInput&&gradeInput.value||'').trim();
    var text=(modelInput&&modelInput.value||'').trim();

    var bad=false;
    if(brandField) brandField.classList.remove('tpf-has-error');
    if(wattField) wattField.classList.remove('tpf-has-error');
    if(pinField) pinField.classList.remove('tpf-has-error');
    if(!brand){ if(brandField) brandField.classList.add('tpf-has-error'); bad=true; }
    if(!text){                                                  // spec path: brand + wattage + pin all required
      if(!wattStr){ if(wattField) wattField.classList.add('tpf-has-error'); bad=true; }
      if(!pin){ if(pinField) pinField.classList.add('tpf-has-error'); bad=true; }
    }                                                           // model/part path: wattage + pin optional, the part number resolves them
    if(bad) return;

    loading();
    loadFeed().then(function(A){
      var B=brand, W=parseInt(wattStr,10)||0, P=pin, V=0, G=grade;
      var labelParts=[B]; if(G) labelParts.push(G); if(W) labelParts.push(W+'W'); if(P) labelParts.push(P);
      var label, unresolved=false;
      if (text){
        var seed=resolveSeed(A, text, B);
        if (seed){ B=seed.brand||B; P=P||seed.pin; V=seed.volt; if(!W) W=seed.watt; label=(brand||B)+' '+text; }
        else { label=(brand?brand+' ':'')+text; unresolved=true; }
      } else { label=labelParts.join(' '); }

      // Part number typed but not found, and no wattage to fall back on: be honest, show brand options.
      if (unresolved && !W){
        var su=similar(A, B);
        if (su.length){ renderSimilar(su, label, true); return; }
        renderEmpty(label); return;
      }

      var list=compatible(A, B, W, P, V, G);
      if (list.length){ renderExact(list, label, (!P && !!W)); return; }
      var sim=similar(A, B);
      if (sim.length){ renderSimilar(sim, label, false); return; }
      renderEmpty(label);
    }).catch(function(){
      resultsWrap.setAttribute('data-has','1');
      resultsWrap.innerHTML='<div class="tpf-empty"><div class="tpf-empty__h">Could not load live stock just now</div><p class="tpf-empty__p">Please try again in a moment, or send your adapter photo on WhatsApp and we will find it.</p><a class="tpf-wa-btn" href="'+waLink(brand)+'" target="_blank" rel="noopener">'+waSvg()+'Ask on WhatsApp</a></div>';
    });
  }

  if (form) form.addEventListener('submit', function(e){ e.preventDefault(); doSearch(); });
  if (wattSelect) wattSelect.addEventListener('change', function(){ if(wattField) wattField.classList.remove('tpf-has-error'); syncGradeVisibility(); if(resultsWrap&&resultsWrap.getAttribute('data-has')==='1') doSearch(); });
  if (modelInput) modelInput.addEventListener('input', function(){ if(wattField) wattField.classList.remove('tpf-has-error'); if(pinField) pinField.classList.remove('tpf-has-error'); });

  function warm(){ loadFeed().catch(function(){}); }
  if (window.requestIdleCallback) requestIdleCallback(warm,{timeout:3000}); else setTimeout(warm,1500);
})();